/**
 * Pure helpers for ingesting source files into the chat composer.
 *
 * Kept side-effect-free so the caller (Chat.jsx today, anyone else
 * tomorrow) can decide whether to surface skips as toasts, modal errors,
 * silent counters, etc.
 */
export const ACCEPTED_EXTENSIONS = [
  ".rpgle", ".rpg", ".sqlrpgle",
  ".clle", ".cl", ".clp",
  ".dds", ".pf", ".lf",
  ".sql", ".ddl",
  ".txt", ".json", ".xml", ".yaml", ".yml", ".md",
];

const MAX_BYTES = 1024 * 1024;

export function detectLanguage(filename = "") {
  const lower = filename.toLowerCase();
  if (lower.endsWith(".rpgle") || lower.endsWith(".rpg") || lower.endsWith(".sqlrpgle")) return "rpg";
  if (lower.endsWith(".clle") || lower.endsWith(".cl") || lower.endsWith(".clp")) return "cl";
  if (lower.endsWith(".dds") || lower.endsWith(".pf") || lower.endsWith(".lf")) return "dds";
  if (lower.endsWith(".sql") || lower.endsWith(".ddl")) return "sql";
  if (lower.endsWith(".json")) return "json";
  if (lower.endsWith(".xml")) return "xml";
  if (lower.endsWith(".yaml") || lower.endsWith(".yml")) return "yaml";
  return "";
}

export function isAcceptedFile(filename = "") {
  const lower = filename.toLowerCase();
  return ACCEPTED_EXTENSIONS.some((ext) => lower.endsWith(ext));
}

/**
 * Read a FileList (or array of File) into chat attachments.
 * Returns `{ attachments, skippedType, skippedSize }` — caller decides
 * how to surface errors.
 */
export async function readFilesToAttachments(files) {
  const attachments = [];
  const skippedSize = [];
  let skippedType = 0;

  for (const f of files) {
    if (!isAcceptedFile(f.name)) {
      skippedType += 1;
      continue;
    }
    if (f.size > MAX_BYTES) {
      skippedSize.push(f.name);
      continue;
    }
    const text = await f.text();
    attachments.push({
      uid: `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
      name: f.name,
      language: detectLanguage(f.name),
      content: text,
    });
  }
  return { attachments, skippedType, skippedSize };
}
